export const SET_ACTIVE_STIMULATION_CHART = 'SET_ACTIVE_STIMULATION_CHART';
export const SET_STIMULATION_LIST = 'SET_STIMULATION_LIST';
export const UPDATE_STIMULATION_LIST = 'UPDATE_STIMULATION_LIST';
export const SET_PRINT = 'SET_PRINT';
